const reunionSet = ({ event, year, location, reunion }, filenames, base = "/api/reunion-uploads/") =>
  filenames.map((filename, index) => ({
    id: `${year}-${filename}`,
    src: `${base}${filename}`,
    alt: `Classmates at ${event}, archive photograph ${index + 1}`,
    event,
    year,
    location,
    reunion,
  }));

export const homeGalleryPhotos = Object.freeze([
  ...reunionSet(
    { event: "Varsham 30", year: 2025, location: "Kochi", reunion: "/reunions/reunion-2025" },
    [
      "2025-DSC06358.jpg",
      "2025-DSC06372.jpg",
      "2025-DSC06385.jpg",
      "2025-DSC06400.jpg",
      "2025-DSC06413.jpg",
      "2025-DSC06426.jpg",
      "2025-DSC06439.jpg",
      "2025-DSC06452.jpg",
      "2025-DSC06465.jpg",
      "2025-DSC06478.jpg",
      "2025-DSC06493.jpg",
      "2025-DSC06506.jpg",
      "2025-DSC06519.jpg",
      "2025-DSC06532.jpg",
      "2025-DSC06558.jpg",
      "2025-DSC06571.jpg",
      "2025-DSC06585.jpg",
      "2025-DSC06611.jpg",
      "2025-DSC06703.jpg",
      "2025-DSC06716.jpg",
      "2025-DSC06742.jpg",
      "2025-DSC06756.jpg",
      "2025-DSC06770.jpg",
      "2025-DSC06783.jpg",
      "2025-DSC06796.jpg",
      "2025-DSC06875.jpg",
      "2025-DSC07006.jpg",
      "2025-DSC07059.jpg",
      "2025-DSC07203.jpg",
      "2025-DSC07532.jpg",
    ],
  ),
  ...reunionSet(
    { event: "Varsham 25", year: 2023, location: "Kochi", reunion: "/reunions/reunion-2023" },
    [
      "2023-varsham-25-005.jpg",
      "2023-varsham-25-009.jpg",
      "2023-varsham-25-013.jpg",
      "2023-varsham-25-017.jpg",
      "2023-varsham-25-025.jpg",
      "2023-varsham-25-029.jpg",
      "2023-varsham-25-037.jpg",
      "2023-varsham-25-040.jpg",
      "2023-varsham-25-044.jpg",
      "2023-varsham-25-052.jpg",
      "2023-varsham-25-056.jpg",
      "2023-varsham-25-080.jpg",
      "2023-varsham-25-088.jpg",
      "2023-varsham-25-116.jpg",
      "2023-varsham-25-151.jpg",
    ],
  ),
  ...reunionSet(
    { event: "Bangalore Reunion", year: 2019, location: "Bangalore", reunion: "/reunions/reunion-2019-class-reunion" },
    [
      "2019-reunion-pictures-001.jpg",
      "2019-reunion-pictures-012.jpg",
      "2019-reunion-pictures-024.jpg",
      "2019-reunion-pictures-030.jpg",
      "2019-reunion-pictures-041.jpg",
      "2019-reunion-pictures-047.jpg",
      "2019-reunion-pictures-058.jpg",
      "2019-reunion-pictures-064.jpg",
      "2019-reunion-pictures-070.jpg",
      "2019-reunion-pictures-081.jpg",
      "2019-reunion-pictures-087.jpg",
      "2019-reunion-pictures-099.jpg",
      "2019-reunion-pictures-104.jpg",
      "2019-reunion-pictures-110.jpg",
      "2019-reunion-pictures-116.jpg",
      "2019-reunion-pictures-127.jpg",
      "2019-reunion-pictures-139.jpg",
      "2019-reunion-pictures-156.jpg",
    ],
  ),
  ...reunionSet(
    { event: "Varsham 20", year: 2015, location: "Kothamangalam", reunion: "/reunions/reunion-2015" },
    [
      "2015-varsham-20-001.jpg",
      "2015-varsham-20-008.jpg",
      "2015-varsham-20-023.jpg",
      "2015-varsham-20-038.jpg",
      "2015-varsham-20-046.jpg",
      "2015-varsham-20-061.jpg",
      "2015-varsham-20-068.jpg",
      "2015-varsham-20-076.jpg",
      "2015-varsham-20-083.jpg",
      "2015-varsham-20-098.jpg",
      "2015-varsham-20-106.jpg",
      "2015-varsham-20-113.jpg",
      "2015-varsham-20-128.jpg",
      "2015-varsham-20-143.jpg",
      "2015-varsham-20-151.jpg",
      "2015-varsham-20-158.jpg",
      "2015-varsham-20-166.jpg",
      "2015-varsham-20-180.jpg",
      "2015-varsham-20-240.jpg",
      "2015-varsham-20-323.jpg",
    ],
  ),
  ...reunionSet(
    { event: "Varsham 15", year: 2010, location: "Kothamangalam", reunion: "/reunions/reunion-2010" },
    [
      "2010-varsham-15-02.jpg",
      "2010-varsham-15-03.jpg",
      "2010-varsham-15-08.jpg",
      "2010-varsham-15-10.jpg",
      "2010-varsham-15-12.jpg",
      "2010-varsham-15-13.jpg",
      "2010-varsham-15-14.jpg",
      "2010-varsham-15-16.jpg",
      "2010-varsham-15-27.jpg",
      "2010-varsham-15-30.jpg",
    ],
  ),
  ...reunionSet(
    { event: "Global Reunion", year: 2005, location: "Dubai", reunion: "/reunions/reunion-2005" },
    [
      "32860031.JPG",
      "32860036.JPG",
      "32860062.JPG",
      "32860071.JPG",
      "32860082.JPG",
      "DSC02461.JPG",
      "DSCF0540.JPG",
    ],
    "/media/reunions/2005/",
  ),
]);

const shuffledGallery = (() => {
  const photos = [...homeGalleryPhotos];
  let seed = 1995;

  for (let index = photos.length - 1; index > 0; index -= 1) {
    seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
    const swapIndex = seed % (index + 1);
    [photos[index], photos[swapIndex]] = [photos[swapIndex], photos[index]];
  }

  return Object.freeze(photos);
})();

const positiveModulo = (value, divisor) => ((value % divisor) + divisor) % divisor;

export function homeGalleryForMinute(minuteNumber) {
  const minute = Number.isFinite(minuteNumber) ? Math.trunc(minuteNumber) : 0;
  const photosPerEdition = 5;
  const editionsPerCycle = shuffledGallery.length / photosPerEdition;
  const cycleOffset = Math.floor(minute / editionsPerCycle) * 17;
  const start = positiveModulo((minute * photosPerEdition) + cycleOffset, shuffledGallery.length);

  return Array.from(
    { length: photosPerEdition },
    (_, index) => shuffledGallery[(start + index) % shuffledGallery.length],
  );
}
